import {useMemo} from 'react';

import {Stack} from 'shells/layout/stack/stack';
import {Leaderboard} from 'shells/leaderboard/leaderboard';
import type {EntityLeaderboardRowData, OtherLeaderboardRows} from 'shells/leaderboard/types';

import type {AiUserFragment, AiFeatureFragment} from 'nutshell-graphql-types';

import {mapTopAiUsersToLeaderboardRows, mapTopAiFeaturesToLeaderboardRows} from './helpers';

import styles from './usage-section.module.css';

interface Props {
    topAiUsers?: AiUserFragment[];
    topAiFeatures?: AiFeatureFragment[];
    isLoading: boolean;
    displayPeriod: string;
    showOutcomeCount: boolean;
}

const LOADING_PROPS = {fill: 'aiPurpleBorder' as const};

export function UsageLeaderboards(props: Props) {
    const topAiUsersRows: EntityLeaderboardRowData[] = useMemo(
        () => mapTopAiUsersToLeaderboardRows(props.topAiUsers, props.showOutcomeCount),
        [props.topAiUsers, props.showOutcomeCount]
    );

    const topAiFeaturesRows: OtherLeaderboardRows = useMemo(
        () => mapTopAiFeaturesToLeaderboardRows(props.topAiFeatures, props.displayPeriod),
        [props.topAiFeatures, props.displayPeriod]
    );

    if (props.topAiUsers == null) {
        return null;
    }

    const loadingProps = {...LOADING_PROPS, isLoading: props.isLoading};

    return (
        <Stack isHorizontal={true} spacing={24} isFullWidth={true}>
            <div className={styles['leaderboard-section']}>
                <Leaderboard
                    title='Top AI users'
                    subtitle={`Time saved this ${props.displayPeriod}`}
                    rowsData={topAiUsersRows}
                    loadingProps={loadingProps}
                />
            </div>
            <div className={styles['leaderboard-section']}>
                <Leaderboard
                    title='Top AI features'
                    subtitle={`Time saved this ${props.displayPeriod}`}
                    rowsData={topAiFeaturesRows}
                    loadingProps={loadingProps}
                />
            </div>
        </Stack>
    );
}
